import { render, staticRenderFns } from "./main-header.vue?vue&type=template&id=7ca70b80&scoped=true&lang=pug"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"
import style0 from "./main-header.vue?vue&type=style&index=0&id=7ca70b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca70b80",
  null
  
)

export default component.exports